import { DetailedTransactionFragment } from '../Sidebar/graphql/fragment/detailedTransaction.gql';

export const getTransactionDescription = (
  transaction: Pick<
    DetailedTransactionFragment,
    'description' | 'paymentMethod' | 'title' | 'type'
  >,
): string | null => {
  const { description, paymentMethod, title, type } = transaction;

  switch (paymentMethod) {
    case 'CHECK':
    case 'CASH_DEPOSIT':
    case 'DIRECT_DEBIT':
      return null;
    case 'INSTANT_TRANSFER':
    case 'TRANSFER':
      return type === 'payin' ? title : description;
    default:
      return description || null;
  }
};
